/**
 * Universal date formatting utilities (browser).
 * Safe date handling for PostgreSQL compatibility.
 */
export function formatDateForInput(dateValue) {
    if (!dateValue)
        return '';
    try {
        let date;
        if (typeof dateValue === 'string') {
            if (!dateValue.trim())
                return '';
            date = new Date(dateValue);
        }
        else if (typeof dateValue === 'object' && dateValue !== null) {
            return '';
        }
        else {
            date = new Date(dateValue);
        }
        if (isNaN(date.getTime())) {
            console.warn('Invalid date value:', dateValue);
            return '';
        }
        if (date.getFullYear() < 1950)
            return '';
        return date.toISOString().split('T')[0];
    }
    catch (error) {
        console.warn('Error formatting date:', dateValue, error);
        return '';
    }
}
export function formatDateForDisplay(dateString) {
    if (!dateString)
        return '';
    try {
        const date = new Date(dateString);
        if (isNaN(date.getTime()))
            return '';
        if (date.getFullYear() < 1950)
            return 'Non spécifié';
        return date.toLocaleDateString('fr-FR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
        });
    }
    catch (error) {
        console.warn('Error formatting date for display:', dateString, error);
        return '';
    }
}
export function formatTimeForDisplay(dateString) {
    if (!dateString)
        return '';
    try {
        const date = new Date(dateString);
        if (isNaN(date.getTime()))
            return '';
        return date.toLocaleTimeString('fr-FR', {
            hour: '2-digit',
            minute: '2-digit',
        });
    }
    catch (error) {
        console.warn('Error formatting time for display:', dateString, error);
        return '';
    }
}
export function formatDateTimeForDisplay(dateString) {
    if (!dateString)
        return '';
    try {
        const date = new Date(dateString);
        if (isNaN(date.getTime()))
            return '';
        return date.toLocaleDateString('fr-FR', {
            weekday: 'long',
            day: '2-digit',
            month: 'long',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
        });
    }
    catch (error) {
        console.warn('Error formatting datetime for display:', dateString, error);
        return '';
    }
}
export function cleanDateForApi(dateValue) {
    if (!dateValue)
        return null;
    if (typeof dateValue === 'string') {
        const trimmed = dateValue.trim();
        if (!trimmed)
            return null;
        try {
            const date = new Date(trimmed);
            if (isNaN(date.getTime()))
                return null;
            if (date.getFullYear() < 1950)
                return null;
            return date.toISOString();
        }
        catch (error) {
            console.warn('Error cleaning date for API:', dateValue, error);
            return null;
        }
    }
    return null;
}
export function getMaxDateForInput() {
    return new Date().toISOString().split('T')[0];
}
export function isMinor(birthDate, cutoffAge = 18) {
    if (!birthDate)
        return false;
    try {
        const birth = new Date(birthDate);
        if (isNaN(birth.getTime()))
            return false;
        const today = new Date();
        const age = today.getFullYear() - birth.getFullYear();
        const monthDiff = today.getMonth() - birth.getMonth();
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
            return age - 1 < cutoffAge;
        }
        return age < cutoffAge;
    }
    catch (error) {
        console.warn('Error checking if minor:', birthDate, error);
        return false;
    }
}
